window.isSwellSetup = false;
(function() {
    $(document).ready(function() {
        var timeInterval = setInterval(function() {
            if (!window.isSwellSetup && typeof(spapi) != "undefined" && spapi.authenticated != undefined) {
                window.isSwellSetup = true;
                clearInterval(timeInterval);
                setTimeout(function(){
                    if(spapi.authenticated) {
                        SwellConfig.Redemption.cartRedemptions("#swell-redemption-options");
                        SwellConfig.Redemption.cartRedemptionDropdown();
                        SwellConfig.Redemption.cartRedemptionsShow();
                        $(".swell-ring-cart").remove();
                    }

                    $('body').on('click', '#swell-redeem-btn', function()
                    {
                        $(".swell-copuon-error").hide();
                        if(spapi.authenticated){
                            if(beforeDiscountRedemption())
                            {
                                $(document).on("swell:cart:updated", function()
                                {
                                    if(window.location.href.indexOf("cart") > -1) {
                                        window.location = "/cart";
                                    }
                                });
                                $("#swell-redeem-btn .btn__content").hide();
                                $(".swell-lds-holder.swell-ring-btn").css("display","flex");
                                redemptionOptionId = parseInt($("#swell-redemption-options").val());
                                redemptionOption = swellAPI.findActiveRedemptionOptionById(redemptionOptionId);
                                swellAPI.refreshCustomerDetails(function() {
                                    if(redemptionOption.amount <= spapi.customer.adjusted_points_balance)
                                    {
                                        result = swellAPI.buyMultipleWithPoints([redemptionOption], function(){
                                            if(window.location.href.indexOf("cart") > -1) {
                                                window.location = "/cart";
                                            }
                                        });
                                    }
                                    else
                                    {
                                        $(".swell-lds-holder.swell-ring-btn").css("display","none");
                                        $("#swell-redeem-btn .btn__content").show();
                                        $(".swell-copuon-error").html("Sorry, you don't have enough points for this reward.");
                                        $(".swell-copuon-error").show();
                                    }
                                });
                            }
                        }
                    });

                    Swell.Cart.items.forEach(function(item) {
                        if (item.properties._swell_discount_type == "cart_fixed_amount") {
                            redeemedRedemptionOption = swellAPI.findActiveRedemptionOptionById(item.properties._swell_redemption_option_id);
                            $(".c-cart__list").append('<li class="c-mini-cart__row c-mini-cart__product" style="color: #337da3"> <div class="c-mini-cart__logo swell-product-image"> <div>'+redeemedRedemptionOption.prettyDiscount+'</div> </div> <div class="c-mini-cart__details swell-cart-item"> <div class="c-mini-cart__product-info"> <p class="c-mini-cart__product-name"> '+redeemedRedemptionOption.name+' </p> <p class="c-mini-cart__label"> </p> </div> <div class="c-mini-cart__input-wrapper "> <input disabled="disabled" type="number" name="updates[]" value="1" min="1" max="1" class="c-mini-cart__input" js-cart-item-price-multiplier="" js-quantity-limiter=""> </div> <div class="c-mini-cart__purchase"> <button class="c-mini-cart__remove swell-coupon-remove"> <img class="c-mini-cart__remove-icon" src="//cdn.shopify.com/s/files/1/0011/8590/6751/t/163/assets/icon-close.svg?v=8529121501404347553"> </button> <p class="c-mini-cart__paragraph"> <strong><span js-cart-item-price-output="">'+redeemedRedemptionOption.cost_text+'</span></strong> </p> </div> </div> </li>');
                            return
                        }
                    });

                    $('body').on('click',".swell-coupon-remove", function(e) {
                        e.preventDefault();
                        $(document).on("swell:cart:updated", function(){
                            if(window.location.href.indexOf("cart") > -1) {
                                window.location = "/cart";
                            }
                            else{
                                $(temp_holder).html(temp);
                                spapi.$.confirm({
                                    title: "Redeemed!",
                                    content: "You have redeemed the discount!",
                                    type: "green",
                                    typeAnimated: true,
                                    useBootstrap: false,
                                    boxWidth: "400px",
                                    buttons: {
                                        ok: {
                                            text: "Ok",
                                            action: function () {
                                            }
                                        }
                                    }
                                });
                            }
                        });
                        $(".swell-coupon-remove").html('<div class="swell-lds-holder swell-ring-remove"><div class="swell-lds-dual-ring swell-ring-remove"></div></div>');
                        $(".swell-coupon-remove .swell-ring-remove").css('display', 'flex');
                        swellAPI.removeRedemptionOptionIdFromCart(redeemedRedemptionOption.id, function(){
                            if(window.location.href.indexOf("cart") > -1) {
                                window.location = "/cart";
                            }
                        });
                    });

                }, 3000);
            }
        }, 1000);
    });
}).call(this);

//redemptions
(function() {
    window.SwellConfig = window.SwellConfig || {};

    SwellConfig.Redemption = {
        cartRedemptions: function(containerSelector) {
            var redemptions = spapi.activeRedemptionOptions;
            redemptions.forEach(function(redemption) {
                if(redemption.discount_type == "cart_fixed_amount") {
                    $(containerSelector).append('<option value="'+ redemption.id +'" >'+redemption.name+'</option>');
                }
            });
        },
        cartRedemptionsShow: function () {
            $(".swell-checkout").show();
        },
        cartRedemptionDropdown: function () {
            $("#swell-redemption-options").prepend("<option value='choose'>Choose your reward</option>");
            $("#swell-redemption-options").val("choose");
            SwellConfig.Redemption.cartRedemptionDropdownUpdate();
            $("#swell-redemption-options").on('change', function()
            {
                SwellConfig.Redemption.cartRedemptionDropdownUpdate();
            });
        },
        cartRedemptionDropdownUpdate: function () {
            if($("#swell-redemption-options").val()=='choose'){
                $("#swell-redeem-btn").attr("disabled", "disabled");
                $("#swell-redeem-btn").css("opacity","0.3");
            }
            else{
                $("#swell-redeem-btn").removeAttr("disabled");
                $("#swell-redeem-btn").css("opacity","1");
            }
        }
    };

}).call(this);


function beforeDiscountRedemption(){
    var redeemedItemsInCart = 0;
    var regularItemsInCart = 0;
    var discountInCart = 0;

    if(Swell.Cart && Swell.Cart.items){
        var cart = Swell.Cart;

        $.each(cart.items, function(index, item){
            if(item.properties._swell_points_used){
                redeemedItemsInCart++;
            } else if(item.line_price > 0){
                regularItemsInCart++;
            }
        });

        Swell.Cart.items.forEach(function(item) {
            if (item.properties._swell_discount_type == "cart_fixed_amount") {
                discountInCart++;
            }
        });
        if(discountInCart > 0){
            $(".swell-copuon-error").html("You already have a redeemed discount in your cart.")
            $(".swell-copuon-error").show();
            return false;
        }
        else if(regularItemsInCart == 0){
            spapi.$.confirm({
                title: "Oops!",
                content: "You must add a priced item in your cart to redeem points for a discount.",
                type: "red",
                typeAnimated: true,
                useBootstrap: false,
                boxWidth: "400px",
                buttons: {
                    ok: {
                        text: "Ok",
                        action: function () {
                        }
                    }
                }
            });
            return false;
        }
        else{
            return true;
        }
    }
};
